import { FC } from "react";

const isBoundNumber = (n?: number) => !isNaN(n!) && isFinite(n!);

interface CountPillProps {
  count?: number;
}

export const CountPill: FC<CountPillProps> = ({ count }) =>
  isBoundNumber(count) ? (
    <span className="inline-block px-1 text-xs font-medium rounded-sm text-icon-base-secondary-a bg-background-badge-grey">
      {count}
    </span>
  ) : null;
